import clsx from 'clsx'

interface PriceProps {
  price: string
  compareAtPrice?: string
  className?: string
}

export function Price({ price, compareAtPrice, className }: PriceProps) {
  const isOnSale = parseFloat(price) < parseFloat(compareAtPrice || '0')

  const formatPrice = (value: string) => {
    return value.replace(/\.(\d)0?$/, '.$10').replace(/\.00$/, '')
  }

  return (
    <p className={clsx(className)}>
      {!isOnSale ? null : (
        <span className="line-through paragraph-s">
          ${formatPrice(compareAtPrice || '')}
        </span>
      )}

      <span className={clsx('paragraph-s', isOnSale ? 'text-brand-sale' : '')}>
        ${formatPrice(price)}
      </span>
    </p>
  )
}
